angular.module('autoremind.reports.unsubscribe')
    .filter('unsubscribeFilter', ['unsubscribeService', function (unsubscribeService) {
        var contentTypeFilter = function (sectedContentType, ItemContentType) {
            if (sectedContentType === 'all') {
                return true;
            }
            ItemContentType = ItemContentType.split(':');
            return sectedContentType === ItemContentType[1];
        };
        var byDateFilter = function (from, to, itemDate) {
            if (from) {
                from = new Date(from);
                if (from > itemDate) {
                    return false;
                }
            }
            if (to) {
                to = new Date(to).getTime() + unsubscribeService.getSecondsToTomorrow();
                if (to < itemDate) {
                    return false;
                }
            }
            return true;
        };
        return function (data, filterParams) {
            if (filterParams.contentType === 'all' && !filterParams.from && !filterParams.to) {
                return data;
            }
            var filteredData = [];
            data.forEach(function (item) {
                if (filterParams.contentType && filterParams.contentType !== 'all' && filterParams.contentType.length > 1 && !contentTypeFilter(filterParams.contentType, item.contentType)) {
                    return;
                }
                if ((filterParams.from || filterParams.to) && !byDateFilter(filterParams.from, filterParams.to, item.modifiedInt)) {
                    return;
                }
                filteredData.push(item);
            });
            return filteredData;
        };
    }])
    .filter('forMessageType', [function () {
        return function (messageType) {
            messageType = messageType.split(':');
            return messageType[1];
        };
    }])
    .filter('iconByMessageType', [function () {
        var iconsByTypes = {
            birthday: 'birthday.png',
            general_message: 'general_message.png',
            reminder: 'general_message.png',
            latepayment: 'latepayment.png',
            missed: 'missed.png',
            triggered: 'triggered.png',
            newsletter: 'newsletter.png',
            recalls: 'recalls.png',
            recall: 'recalls.png',
            sale: 'sale.png',
            seasonal: 'seasonal.png',
            shortnotice: 'shortnotice.png',
            survey: 'survey.png',
            reviews: 'reviews.png',
            twoway: 'two-way.png',
            all: 'general_message.png',
            sms: 'mobile_256x256.png',
            voice: 'phone_256x256.png',
            email: 'mail_256x256.png'
        };
        return function (type) {
            if (!type) {
                return '';
            }
            //console.log('**', type, iconsByTypes[type])
            if (type.indexOf('relation:') !== (-1)) {
                type = type.replace("relation:", "");
            }
            else if (type.indexOf('commercial:') !== (-1)) {
                type = type.replace("commercial:", "");
            }
            else if (type === 'sms' || type === 'voice' || type === 'email') {
                return (typeof iconsByTypes[type] !== 'undefined') ? 'img/' + iconsByTypes[type] : '';
            }
            return (typeof iconsByTypes[type] !== 'undefined') ? 'img/communications/category/' + iconsByTypes[type] : '';
        };
    }])
    .filter('totalPeopleBlocked', function () {
    return function (people) {
        var blockedCount = 0;
        var peopleIds = [];
        people.forEach(function (person) {
            if (peopleIds.indexOf(person.personId) === (-1)) {
                peopleIds.push(person.personId);
                blockedCount++;
            }
        });
        return blockedCount;
    };
});
//# sourceMappingURL=unsubscribe.filters.js.map